import { getDefaultAccessors } from 'src/graphql/entities/custom-view/custom-view-config/utils';
import { CustomViewSortConfigItem } from 'src/graphql/entities/custom-view/custom-view.types';

// The attributes listed here are the only identifiers that will be stored in the database
// to track the user's selection. These attributes should remain abstract and not be
// directly tied to the database schema. Instead, they serve as logical names for the attributes,
// which can be matched to their corresponding configuration and settings in the system.
export const ClientAttribute = {
  id: 'id',
  partner: 'partner',
  partnerName: 'partnerName',
  timeZone: 'timeZone',
  name: 'name',
  firstName: 'firstName',
  lastName: 'lastName',
  phone: 'phone',
  email: 'email',
  marketingOptOut: 'marketingOptOut',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deleted: 'deleted',
  deletedAt: 'deletedAt',
} as const;

export type ClientAttributeType = (typeof ClientAttribute)[keyof typeof ClientAttribute];

export const ClientAttributeAccessors: Record<ClientAttributeType, CustomViewSortConfigItem> =
  {
    [ClientAttribute.id]: getDefaultAccessors('id'),
    [ClientAttribute.partner]: getDefaultAccessors('partnerId'),
    [ClientAttribute.partnerName]: getDefaultAccessors('partner.businessName'),
    [ClientAttribute.timeZone]: getDefaultAccessors('partner.timeZone'),
    [ClientAttribute.createdAt]: getDefaultAccessors('createdAt'),
    [ClientAttribute.deletedAt]: getDefaultAccessors('deletedAt'),
    [ClientAttribute.updatedAt]: getDefaultAccessors('updatedAt'),
    [ClientAttribute.name]: {
      sort: 'firstName',
      // self attribute reference, means attribute cant be handled using single attribute and requires manual mapping logic
      filter: ClientAttribute.name,
      display: 'fullName',
    },
    [ClientAttribute.firstName]: getDefaultAccessors('firstName'),
    [ClientAttribute.lastName]: getDefaultAccessors('lastName'),
    [ClientAttribute.phone]: {
      sort: 'primaryPhoneNumber/value',
      filter: ClientAttribute.phone,
      display: 'primaryPhoneNumber',
    },
    [ClientAttribute.email]: {
      sort: 'primaryEmail/value',
      filter: 'primaryEmail/value',
      display: 'primaryEmail',
    },
    [ClientAttribute.marketingOptOut]: {
      sort: 'marketingOptOut',
      filter: 'marketingOptOut',
      display: 'marketingOptOut',
      aggFunction: 'bool_or',
    },
    [ClientAttribute.deleted]: {
      filter: 'deletedAt',
      display: 'deletedAt',
    },
  };
